<section
  class="rs-content-wrapper rs-header-has-level2"
  *ngIf="!error || pending || productsLoaded"
  id="nspActivationMobileContainer"
>
  <mprd-nsp-activation-skeleton *ngIf="!productsLoaded"></mprd-nsp-activation-skeleton>
  <main id="maincontent" role="main" *ngIf="productsLoaded">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-txt-c2 rs-has-subtit" data-cy="nspActivationMobileTitle">
            {{ 'nsp.activationMobile.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <h2 class="rs-tit3">{{ subtitleKey | translate }}</h2>
            <p
              data-cy="nspActivationMobileDescription"
              [innerHTML]="'nsp.activationMobile.description' | translate"
            ></p>

            <mprd-nsp-mobile-list-component
              [products]="mobileProducts"
              (hasChanged)="handleHasChanged($event)"
              data-cy="nspActivationMobileList"
            ></mprd-nsp-mobile-list-component>
            <div class="rs-me"></div>
            <button
              class="rs-btn"
              aria-haspopup="true"
              [disabled]="isStandalone && !hasChanged"
              (click)="continueToActivate()"
              data-cy="nspActivationMobileContinueButton"
              data-tms-event="button-click"
              data-tms-button-zone="nsp"
              attr.data-tms-button-name="{{ 'nsp.activationMobile.button.continue' | translate }}"
            >
              {{ 'nsp.activationMobile.button.continue' | translate }}
            </button>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
